/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { TParams } from '@global-types/app/app';
import {
	formatNumberWithSpaces,
	formatTokenAvailable,
} from '@utils/formats';
import { randomId } from '@mantine/hooks';
import isNil from 'lodash/isNil';
import { NOT_APPLICABLE } from '@config/constants/common';
import { getUnitLabel } from '@utils/units';
import isNumber from 'lodash/isNumber';
import {
	TAdditionalityProject,
	TMeasurabilityProject,
} from '@global-types/api/api';
import { convertGCO2EToTCO2EWithoutUnit } from '@utils/functions';

export type TParsedRowMeasurabilityProject = {
	id: string;
	name: string;
	price: number;
	availableStock: string;
};

export type TParsedRowAdditionalityProject = {
	id: string;
	name: string;
	target_euro: number;
	coverage: number;
};

export const getUsers = (
	params: any
): Promise<{
	rows: any[];
	total: number;
	page: number;
	pageSize: number;
	totalPages: number;
}> => {
	return apiClient.get('/users', {
		params: {
			query: params,
			pageSize: 1000,
		},
	});
};

export const useUsers = (
	enabled: { enabled: boolean },
	queryParams?: TParams
) => {
	const { data, isFetching, isFetched } = useQuery({
		queryKey: ['users', { queryParams: queryParams }],
		queryFn: () => getUsers(queryParams),
		staleTime: 0,
		enabled: enabled.enabled,
	});

	const updateList = (users: any) =>
		users && Array.isArray(users)
			? users.reduce((acc: any, currentItem: any) => {
					const modifiedItem = {
						...currentItem,
					};
					acc.push(modifiedItem);

					return acc;
				}, [])
			: [];

	return {
		data: data ? updateList(data?.rows) : [],
		isLoading: isFetching && !isFetched,
		isFetched,
		total: data?.total,
		page: data?.page,
		pageSize: data?.pageSize,
		totalPages: data?.totalPages,
	};
};
